export const HELP_TOPIC_IDS = ["mhov"] as const;

export type HelpTopicId = (typeof HELP_TOPIC_IDS)[number];

export interface HelpTopicUnreadInput {
  readonly topicId: HelpTopicId;
  readonly helpNotificationsEnabled: boolean;
  readonly isTopicAvailable: boolean;
  readonly readHelpTopicIds: readonly HelpTopicId[];
}

export function isHelpTopicId(value: unknown): value is HelpTopicId {
  return value === "mhov";
}

export function normalizeHelpTopicIds(value: unknown): HelpTopicId[] {
  if (!Array.isArray(value)) {
    return [];
  }

  const seen = new Set<HelpTopicId>();
  const result: HelpTopicId[] = [];
  for (const item of value) {
    if (!isHelpTopicId(item) || seen.has(item)) {
      continue;
    }
    seen.add(item);
    result.push(item);
  }
  return result;
}

export function isHelpTopicUnread(input: HelpTopicUnreadInput): boolean {
  return (
    input.helpNotificationsEnabled &&
    input.isTopicAvailable &&
    !input.readHelpTopicIds.includes(input.topicId)
  );
}

export function hasUnreadHelpTopic(input: {
  readonly helpNotificationsEnabled: boolean;
  readonly availableTopicIds: readonly HelpTopicId[];
  readonly readHelpTopicIds: readonly HelpTopicId[];
}): boolean {
  return input.availableTopicIds.some((topicId) =>
    isHelpTopicUnread({
      topicId,
      helpNotificationsEnabled: input.helpNotificationsEnabled,
      isTopicAvailable: true,
      readHelpTopicIds: input.readHelpTopicIds,
    }),
  );
}
